<!-- app.component.html -->
<div>
  <!-- <h1>{{ title }}</h1> -->
  <router-outlet></router-outlet>  <!-- This is where routed components will be displayed -->
</div>

@if (showInstallPopup()) {
  <div class="fixed top-6 inset-x-0 flex justify-center z-50 animate-slideDown">
  <div
    class="bg-white shadow-lg rounded-lg px-5 py-3 flex items-center gap-4 border border-gray-200"
  >
    <span class="text-gray-800 font-medium">{{'common.INSTALL_THIS_APP' | translate}}</span>

    <button tabindex="-1"
      (click)="installPwa()"
      class="bg-[var(--primary-color)] text-white px-4 py-1.5 rounded-lg text-sm hover:bg-opacity-90 transition"
    >
    {{'common.INSTALL' | translate}}
    </button>

    <button
      (click)="closePopup()"
      class="text-gray-500 hover:text-gray-700 text-sm font-medium cursor-pointer"
    >
      ✕
    </button>
  </div>
</div>

}

@if (showInstalledPopup()) {
  <div class="fixed top-6 inset-x-0 flex justify-center z-50 animate-slideDown">
  <div
    class="bg-white shadow-lg rounded-lg px-5 py-3 flex items-center gap-4 border border-gray-200"
  >
    <span class="text-gray-800 font-medium">{{'common.APP_INSTALLED_SUCCESSFULLY' | translate}}</span>

    <button tabindex="-1"
      (click)="openInstalledApp()"
      class="bg-[var(--primary-color)] text-white px-4 py-1.5 rounded-lg text-sm hover:bg-opacity-90 transition"
    >
    {{'common.OPEN_APP' | translate}}
    </button>

    <button
      (click)="closePopup()"
      class="text-gray-500 hover:text-gray-700 text-sm font-medium cursor-pointer"
    >
      ✕
    </button>
  </div>
</div>

}

@if (showIosInstallPopup()) {
  <div class="fixed top-6 inset-x-0 flex justify-center z-50 animate-slideDown">
  <div
    class="bg-white shadow-lg rounded-lg px-5 py-3 flex items-center gap-4 border border-gray-200 max-w-[calc(100%-2rem)]"
  >
    <span class="text-gray-800 font-medium">{{'common.IOS_INSTALL_INSTRUCTIONS' | translate}}</span>

    <button
      (click)="closePopup()"
      class="bg-[var(--primary-color)] text-white px-4 py-1.5 rounded-lg text-sm hover:bg-opacity-90 transition"
    >
    {{'common.OKAY' | translate}}
    </button>
  </div>
</div>

}
